// extracted by mini-css-extract-plugin
module.exports = {"wellcome":"HomePage__wellcome___Pt2cM","image":"HomePage__image___WpEAU","content":"HomePage__content___3JMdE","h1":"HomePage__h1___2wW6f","p":"HomePage__p___ow_1K"};